import N8nCanvasPill from './CanvasPill.vue';

export default N8nCanvasPill;
